/** A retired DB record must not be rendered, even in an older API response. */
export function isLeaveRecordVisible(value: unknown): boolean {
  if (!value || typeof value !== 'object') return true;
  const row = value as Record<string, unknown>;
  return ![
    row.isDeleted, row.is_deleted,
    row.leaveTypeIsDeleted, row.leave_type_is_deleted,
  ].some(flag => flag === true || flag === 1 || flag === '1' || flag === 'true');
}
